import { useMemo } from "react";
import { frameSvg } from "./frameArt";

/**
 * Gambar bulat kanak-kanak dengan bingkai bermusim (overlay SVG).
 * size = diameter gambar (px). Bingkai melimpah 25% di setiap sisi.
 */
export default function FramedPhoto({ src, name, frame, size = 96, className = "", imgClassName = "", fallback = null, onClick }) {
  const svg = useMemo(() => (frame ? frameSvg(frame) : ""), [frame]);
  return (
    <div className={`relative ${className}`} style={{ width: size, height: size }} onClick={onClick} data-testid={frame ? `framed-photo-${frame}` : "framed-photo"}>
      {src ? (
        <img src={src} alt={name || ""} className={`w-full h-full rounded-full object-cover ${imgClassName}`} loading="lazy" />
      ) : (
        fallback
      )}
      {frame && (
        <div
          aria-hidden
          className="pointer-events-none absolute frame-pop"
          style={{ width: size * 1.5, height: size * 1.5, left: -size * 0.25, top: -size * 0.25 }}
          dangerouslySetInnerHTML={{ __html: svg }}
        />
      )}
      <style>{`.frame-pop svg{width:100%;height:100%;overflow:visible}.frame-pop{animation:framePop .6s cubic-bezier(.34,1.56,.64,1) both}@keyframes framePop{from{opacity:0;transform:scale(.85) rotate(-6deg)}to{opacity:1;transform:none}}`}</style>
    </div>
  );
}
